const axios = require("axios");

export async function createCheckoutSession({ transactionId, locationId, locationMetaId }) {
  if (!transactionId) {
    throw new Error(
      "Please provide a transactionId parameter to createCheckoutSession"
    );
  }
  if (!locationId) {
    throw new Error(
      "Please provide an locationId parameter to createCheckoutSession"
    );
  }
  try {
    const createResults = await axios({
      method: "POST",
      url: `${process.env.REACT_APP_CRM_API_URL}/createCheckoutSession`,
      data: {
        transactionId,
        locationId,
        locationMetaId,
      },
    });
    if (createResults && createResults.data && createResults.data.id) {
      return { success: true, sessionId: createResults.data.id };
    } else {
      throw new Error("createResults are malformed.");
    }
  } catch (error) {
    return { success: false, error };
  }
}
